import React, { useState, useEffect } from 'react'
import { KTIcon } from '../../../../_metronic/helpers'
import BackBtn from '../lib/BackBtn'
import { checkSpecialTicketAttendees, submitSpecialTicketExcel } from '../../../api/report/reportSpecialApi'
import { getOrganizationSpecial } from '../../../api/organization/organizationApi'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'

interface CheckResult {
  total: number
  valid: number
  invalid: {
    total: number
    records: Array<{
      index: number
      nationalCode: number
      status: string
    }>
  }
  status: string
}

type CheckAttendeesResponse = CheckResult

interface Organization {
  id: number
  title: string
  // add other organization properties if needed
}

function AddExcelTicketSpecial() {
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const [isFileChecked, setIsFileChecked] = useState(false)
  const [male, setMale] = useState<boolean | null>(null)
  const [checkResult, setCheckResult] = useState<CheckResult | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [selectedOrganization, setSelectedOrganization] = useState<number | null>(null)

  const { data: organizations = [], isLoading: isLoadingOrganizations } = useQuery<Organization[]>(
    ['organizations'],
    getOrganizationSpecial
  )

  const genderOptions = [
    { id: 'male', name: 'آقا' },
    { id: 'female', name: 'خانم' },
  ]

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      setSelectedFile(event.target.files[0])
    }
  }

  const handleSubmit = async () => {
    if (!selectedFile) {
      alert('لطفا یک فایل انتخاب کنید')
      return
    }
    if (!selectedOrganization) {
      alert('لطفا سازمان را انتخاب کنید')
      return
    }
    
    try {
      setIsLoading(true)
      const result = await checkSpecialTicketAttendees(selectedFile, selectedOrganization as number)
      setCheckResult(result as CheckResult)
      setIsFileChecked(true)
    } catch (error: any) {
      console.error('Error checking file:', error)
      if (error.response?.status === 400) {
        toast.error(error.response.data.message || 'تعداد بلیط‌های انتخاب شده بیشتر از حد مجاز است')
      } else {
        toast.error('خطا در بررسی فایل')
      }
    } finally {
      setIsLoading(false)
    }
  }

  const handleFinalSubmit = async () => {
    if (male === null) {
      alert('لطفا جنسیت را انتخاب کنید')
      return
    }
    if (!selectedOrganization) {
      alert('لطفا سازمان را انتخاب کنید')
      return
    }
    if (!selectedFile) {
      alert('لطفا یک فایل انتخاب کنید')
      return
    }

    try {
      setIsSubmitting(true)
      const result = await submitSpecialTicketExcel(selectedFile, selectedOrganization, male)
      if (result.success) {
        toast.success('بلیت‌ها با موفقیت صادر شدند')
        // Reset form
        setSelectedFile(null)
        setIsFileChecked(false)
        setMale(null)
        setCheckResult(null)
        setSelectedOrganization(null)
        // Reset file input
        const fileInput = document.getElementById('excelFileInput') as HTMLInputElement
        if (fileInput) {
          fileInput.value = ''
        }
      } else {
        toast.error('خطا در صدور بلیت')
      }
    } catch (error: any) {
      console.error('Error submitting file:', error)
      if (error.response?.status === 400) {
        toast.error(error.response.data.message || 'خطا رخ داده است')
      } else {
        toast.error('خطا در صدور بلیت')
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  const goBack = () => {
    window.history.back();
  }

  return (
    <div className={"card p-4"}>
      <div className="d-flex justify-content-between align-items-center mb-5">
        <h2>دریافت با اکسل بلیت ویژه</h2>
        <BackBtn onClick={() => goBack()} />
      </div>

      <div className="col-12 col-lg-6 mb-12 d-flex gap-2">
        <input
          type="file"
          className="d-none"
          accept=".xls,.xlsx"
          onChange={handleFileChange}
          name="file"
          id="excelFileInput"
        />
        <button
          type="button"
          className="btn btn-success"
          onClick={() => {
            document.getElementById("excelFileInput")?.click()
          }}
        >
          دریافت از فایل اکسل
          <KTIcon iconName="file" className="fs-2 me-2" />
        </button>
      </div>

      <div className="col-12 col-lg-6 mb-12">
        <label htmlFor="organization" className="form-label fw-bold mb-4">
          انتخاب سازمان
        </label>
        <select
          name="organization"
          className="form-select mb-4"
          value={selectedOrganization || ''}
          onChange={(e) => {
            setSelectedOrganization(Number(e.target.value))
          }}
          disabled={isLoadingOrganizations}
        >
          <option value="">انتخاب سازمان</option>
          {organizations.map((org) => (
            <option
              value={org.id}
              key={org.id}
            >
              {org.title}
            </option>
          ))}
        </select>
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={!selectedFile || !selectedOrganization || isLoading}
        >
          {isLoading ? 'در حال بررسی...' : 'بررسی اکسل'}
        </button>
      </div>
      <div className='bg-red-600'>لیست فقط از یک نوع جنسیت (اقا یا خانم) باید باشد  </div>

      {checkResult && (
        <div className="col-12 mt-5">
          <div className="card">
            <div className="card-body">
              <h4 className="mb-4">نتیجه بررسی فایل</h4>
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>تعداد کل</th>
                      <th>تعداد معتبر</th>
                      <th>تعداد نامعتبر</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{checkResult.total}</td>
                      <td className="text-success">{checkResult.valid}</td>
                      <td className="text-danger">{checkResult.invalid.total}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {checkResult.invalid.total > 0 && (
                <div className="mt-5">
                  <h5 className="text-danger mb-4">ردیف‌های نامعتبر</h5>
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th>ردیف</th>
                          <th>کد ملی</th>
                          <th>وضعیت</th>
                        </tr>
                      </thead>
                      <tbody>
                        {checkResult.invalid.records.map((record) => (
                          <tr key={record.index}>
                            <td>{record.index}</td>
                            <td>{record.nationalCode}</td>
                            <td>{record.status === 'booked' ? 'قبلا بلیت صادر شده' : 
                                record.status === 'invalid' ? 'فرمت کد ملی نامعتبر است' : 
                                record.status === 'duplicated' ? 'رکورد تکراری در فایل اکسل' : 
                                record.status}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {isFileChecked && checkResult && checkResult.valid > 0 && (
        <div className="col-12 mt-5">
          <div className="row mb-5">
            <div className="col-12 col-lg-6">
              <label htmlFor="gender" className="form-label fw-bold">
                جنسیت
              </label>
              <select
                name="male"
                className="form-select"
                value={male === true ? 'male' : male === false ? 'female' : ''}
                onChange={(e) => {
                  const isMale = e.target.value === "male";
                  setMale(isMale);
                }}
              >
                <option value="">انتخاب جنسیت</option>
                {genderOptions.map((option, index) => (
                  <option
                    value={option.id}
                    key={index}
                  >
                    {option.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="d-flex justify-content-strat gap-4">
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleFinalSubmit}
              disabled={male === null || !selectedOrganization || isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span className="ms-2">در حال صدور بلیت...</span>
                </>
              ) : (
                'صدور بلیت'
              )}
            </button>
            <div className='pt-5'> صدور بلیت صرفا برای رکوردهای قابل قبول امکان پذیر است </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default AddExcelTicketSpecial